import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoDelIcon from '@jwp/ott-theme/assets/icons/Info_del.svg?react';

import Dialog from '../Dialog/Dialog';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';

import styles from './LiveStreamIssueDialog.module.scss';

type Props = {
  open: boolean;
  onOkay: () => void;
};

const LiveStreamIssueDialog: React.FC<Props> = ({ open, onOkay }) => {
  const { t } = useTranslation(['video', 'common']);

  return (
    <Dialog open={open} onClose={onOkay} role="alertdialog" size="small-2">
      <div className={styles.content}>
        <div className={styles.iconWrap} aria-hidden="true">
          <Icon icon={InfoDelIcon} className={styles.icon} />
        </div>
        <h2 className={styles.title}>
          {t('video:player_error.live_unavailable_title', { defaultValue: 'Just a moment!' })}
        </h2>
        <p className={styles.body}>
          {t('video:player_error.live_unavailable_description', {
            defaultValue: 'The live broadcast will be available shortly. Please check back in a few moments.',
          })}
        </p>
        <Button
          className={styles.okayButton}
          label={t('common:okay', { defaultValue: 'Okay' })}
          variant="contained"
          color="primary"
          onClick={onOkay}
          fullWidth
        />
      </div>
    </Dialog>
  );
};

export default LiveStreamIssueDialog;
